import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';

import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/_core/auth.service';
import { EntityService } from 'src/app/_core/entity.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';
import { GeneralUtilsService } from 'src/app/_services/general.utils.service';
import { DialogsService } from 'src/app/_services/dialogs.service';

import { routerTransition } from 'src/app/_core/static/animations';
import { TipDialogComponent } from 'src/app/tabit-pay/_dialogs/tip-dialog/tip-dialog.component';

import * as _ from 'lodash';
import {OrderService} from "../_services/order.service";
import {SharedOrderManageComponent} from "../shared-order/shared-order-manage/shared-order-manage.component";
declare const $: any;

@Component({
    selector: 'app-tabit-pay',
    templateUrl: './tabit-pay.component.html',
    styleUrls: ['./tabit-pay.component.scss'],
    host: {
        'class': 'host-default trans-overlay',
        //'[@routerTransition]': '',
    },
    animations: [
        routerTransition
    ],
    standalone: false
})
export class TabitPayComponent implements OnInit, OnDestroy {
	@ViewChild('appSidenav', { static: false }) public appSidenav: MatSidenav;

	private signinSubscription: Subscription = null;

	loading: boolean = true;
	loadingStep: boolean = false;
	site: any;
	siteName: string = '...';
	step: number = 0;

	stepsMap = {
		'enter': 0,
		'ticket': 1,
		'partial': 3,
		'pay': 4,
		'menu': 5
	}

	pms: any = [];
	date = new Date();
	$storage: any = {};
	fromState: string = "/pay/sites;service=pay";

	childOptions: any = {
		direction: 1,
		stepDirectionClass: 'faster slideInLeft',
		startBlock: () => { this.appService.blockUI.start() },
		stopBlock: () => { this.appService.blockUI.stop() }
	}

	constructor(
		public appService: AppService,
		public entityService: EntityService,
		public authService: AuthService,
		public tabitPayService: TabitPayService,
		public orderService: OrderService,
		public generalUtils: GeneralUtilsService,
		public dialogsService: DialogsService,
		public router: Router,
		private route: ActivatedRoute,
		public elementRef: ElementRef,
		public dialog: MatDialog,
	) {
		let that = this;
		let params = this.appService.urlParams;
		sessionStorage.removeItem('orderCache');
		this.orderService.clearOrder();
		if (!params.site || params.virtualSite) {
			this.router.navigate(['/info']);
			return;
		}

		if (params.additems === '1') {
			let message = this.appService.translate("MESSAGES.ITEM_ADDED_SUCCESSFULLY");
			this.appService.animDialog({ title: message, animation: 'fireworks', darkTheme: true, height: 400, loop: false });
			setTimeout(() => {
				const url = new URL(document.location.href);
				url.search = url.search.replace('&additems=1', '');
				document.location.replace(url.href);
			}, 5000);
			return;
		}
		if (params.fromState) this.fromState = params.fromState;

		this.appService.blockUI.start();
		this.init(params).finally(() => {
			this.appService.blockUI.stop();
		});
	}

	async init(params) {
		let site;
		try {
			site = await this.entityService.getSiteConfig(params.site);
		} catch (e) {
			this.appService.removeParamFromURL(['site','oid']);
			this.appService.alert({html: this.appService.translate('MESSAGES.INVALID_ORDER')});
			this.router.navigate(['/info']);
			return;
		}

		try {
			this.tabitPayService.start(site);
			this.$storage = this.tabitPayService.$storage;
			this.$storage.viewHeight = $(window).height();
			this.siteName = site.config.name || '....';

			if (params.oid) {
				await this.lookUpOrder(params.oid)
				this.lookUpOrder(params.oid).then(() => {
					this.appService.trackData('order loaded');
					this.signupPrompt();
					if (sessionStorage.getItem('firstLoad')) {
						if (this.$storage?.order?.isTabOrder) {
							this.appService.alert({
								template: 'message',
								title: this.appService.translate('OAT.order_start_title'),
								content	: this.appService.translate('OAT.order_start_content'),
							}).then(() => {
								this.dialogsService.passOrder();
							});
						} else {
							this.dialogsService.passOrder();
						}
						sessionStorage.removeItem('firstLoad');
					}
				})
			}
			this.loading = false;
		} catch (e) {
			this.appService.removeParamFromURL(['oid']);
			this.appService.alert({html: this.appService.translate('MESSAGES.INVALID_ORDER')});
			if (params.virtualSite) {
				this.router.navigate(['/info']);
			}else {
				this.loading = false;
			}
		}
	}

	//--------------------------------------------------------------->
	// life cycle hooks
	//--------------------------------------------------------------->

	ngOnInit() {
		this.signinSubscription = this.authService.signinChanged$.subscribe(() => {
			if (this.$storage) {
				delete this.$storage.wallet;
				if (this.step >= this.stepsMap.partial) {
					this.loading = true;
					this.tabitPayService.createUserWalletPms();
					setTimeout(() => {
						this.loading = false;
					}, 0);
					return;
				}
				delete this.$storage.wasPrepared;
			}
			if (this.$storage.order?.order_id) {
				this.reloadOrder();
			}
		});
	}
	ngOnDestroy() {
		this.signinSubscription.unsubscribe();
	}

	//--------------------------------------------------------------->
	// data methods
	//--------------------------------------------------------------->

	loadOrder(args) {//siteId, orderId
		this.appService.blockUI.start();
		let that = this;
		this.loading = true;

		let promises = [
			this.entityService.getSiteConfig(args.site)
		];

		Promise.all(promises).then(res => {
			let site = res[0];
			this.tabitPayService.start(site);
			this.$storage = this.tabitPayService.$storage;
			this.siteName = site.config.name || '....';

			return this.tabitPayService.startOrder(args.site, args.oid).then(response => {
				this.setStep(this.stepsMap.ticket);
			});
		}).catch(err => {
			this.appService.alert({ content: this.appService.translate(err.message) });
		}).then(o => {
			this.appService.blockUI.stop();
			this.loading = false;
		});
	}

	onPayment(args?) {
		this.setStep(this.stepsMap.ticket);
		if (args && args.showMessage) {
			let message = this.appService.translate("MESSAGES.PAYMENT_ACCEPTED_SUCCESSFULLY_WITH_AMOUNT", { amount: args.amount });
			this.appService.animDialog({ title: message, animation: 'fireworks', darkTheme: true, height: 400, loop: false });
		}
		this.reloadOrder();
	}

	reloadOrder() {
		this.appService.blockUI.start();
		this.lookUpOrder(this.$storage.order.order_id).catch(err => {
			this.router.navigate(['/info', { state: { data: { message:'MESSAGES.INVALID_ORDER' } } }]);
		}).finally(() => {
			this.appService.blockUI.stop();
		});
	}

	lookUpOrder(orderNO) {
		let that = this;
		if (orderNO) {
			this.appService.blockUI.start();
			return this.tabitPayService.startOrder(this.$storage.organization, orderNO).then(response => {
				this.appService.urlParams.orderValidated = true;
				this.appService.urlParams.shortId = this.$storage.order?._order?.shortId;

				this.prepareSteps();
				this.setStep(this.stepsMap.ticket);
				this.loading = false;
				let paymentProcess = this.appService.urlParams.paymentProcess;
				if (paymentProcess) {
					let wasPaymentProcess = sessionStorage.getItem('wasPaymentProcess');
					if (wasPaymentProcess && wasPaymentProcess.includes(paymentProcess)) return;
					sessionStorage.setItem('wasPaymentProcess', `${wasPaymentProcess}_${paymentProcess}`);

					return this.entityService.get(`/online-shopper/payment-process/${paymentProcess}`, {}, { 'ros-organization': this.$storage.organization }).then(res => {
						switch (_.get(res, 'status')) {
							case "completed":
								let message = this.appService.translate("MESSAGES.PAYMENT_ACCEPTED_SUCCESSFULLY");
								this.appService.animDialog({ title: message, animation: 'fireworks', darkTheme: true, height: 400, loop: false });
								break;
							case "failed": ; case "error": ; case "authorizationCancelled":
								that.appService.alert({ content: "MESSAGES.EX_PAYMENT_ERROR" }).then(() => { });
								break;
						}
					}).catch(err => {
						console.error("Error validating payment", err);
						return;
					});
				}
				this.tabitPayService.checkTabOrderDiner();
			}).catch(err => {
				throw (err);
			}).finally(() => {
				this.appService.blockUI.stop();
			});
		} else {
			return Promise.reject();
		}
	}

	toggleTranslation() {
		this.appService.toggleTranslation();
		this.tabitPayService.orderChangedSource.next();
	}
	toggleAppSidenav() {
		this.appSidenav.toggle();
	}
	onSideNvaAction($event: any) {
		switch ($event) {
			case 'signout': this.authService.signOut(true); break;
			case 'signin': this.dialogsService.login(null, 'sideNav'); break;
			case 'wallet': this.dialogsService.showWallet().then(() => {document.location.reload()}); break;
		}
	}


	//--------------------------------------------------------------->
	// wizard methods
	//--------------------------------------------------------------->

	steps: any = {};

	prepareSteps(mode?) {
		if (!mode) mode = 'partial';
		let _steps = {}
		if (mode == 'full' || mode == 'tip') {
			_steps[1] = {
				'next': this.stepsMap.pay,
				'back': this.stepsMap.ticket
			}
			_steps[4] = {
				'back': this.stepsMap.ticket
			}
		} else {
			_steps[1] = {
				'next': this.stepsMap.partial,
				'back': this.stepsMap.ticket
			}
			_steps[3] = {
				'next': this.stepsMap.pay,
				'back': this.stepsMap.ticket
			}
			_steps[4] = {
				'back': this.stepsMap.partial
			}
		}
		this.childOptions.stepsMode = mode;
		this.steps = _steps;
	}

	signupPrompt(mode?) {
		if (this.appService.user) return;
		if (this.$storage?.order?.isTabOrder) this.dialogsService.login();
		else {
			if (this.appService.region != 'IL' || sessionStorage.getItem("last-signin-prmpt") || this.appService.urlParams.paymentProcess) return;
			//let lastPrompt = sessionStorage.getItem('last-signin-prmpt');
			//if (lastPrompt && moment().diff(lastPrompt, 'minutes') <= 0) return;
			sessionStorage.setItem('last-signin-prmpt', new Date().toISOString());
			this.dialogsService.SignupPrompt('tabitPay').then(res => {
				if (res) {
					this.dialogsService.login(this.$storage.contact, 'prompt', true);
				}
			});
		}
	}

	onCheckSelect(check) {
		console.log(check);
		this.generalUtils.prepareChck(this.$storage, check);
		this.dialogsService.showCheckDialog({
			check: check,
			$storage: this.$storage
		}).then(res => {
			if (res) {
				this.$storage.check = _.cloneDeep(check);
				if (res == 'full') {
					this.showTipDialog({
						orderTotal: this.$storage.check.$$total,
						balanceDue: check.$$balanceDue
					}).then(res => {
						this.gotoPayment('full');
					});
				} else {
					this.gotoPayment(res);
				}
			}
		})
	}

	gotoPaymentClick(mode?, subMode?) {
		if (mode == 'full_tip') {
			this.showTipDialog({
				isTipMode: true,
				orderTotal: this.$storage.order.itemsTotal
			}).then(res => {
				if (!res) return;
				this.gotoPayment('tip');
			});
			return;
		}
		let actions = [
			{ id: 'gotoFullPayment', text: 'full-payment', icon: 'pay-full', active: true },
			{ id: 'gotoPartialPayment', text: 'partial-payment', icon: 'pay-partial', active: true },
		];
		if (mode === 'openTabAllowNonDeposit') {
			actions.unshift({ id: 'payWithSaved', text: 'pay-with-saved', icon: 'file_invoice_dollar', active: true },)
			mode = null;
		}
		if (!mode) { //this.$storage.wasPayment
			this.dialogsService.openBottomSheet({ actions: actions }).then(response => {
				if (response) {
					switch (response["id"]) {
						case "gotoFullPayment":
							if (!this.$storage.enableGratuity) this.gotoPayment('full');
							else this.showTipDialog({
								isTipMode: false,
								orderTotal: this.$storage.order.balanceDue
							}).then(res => {
								if (!res) return;
								this.gotoPayment('full');
							});
							break;
						case "payWithSaved":
							this.dialog.open(SharedOrderManageComponent, {
								panelClass: 'fullscreen-dialog',
								direction: this.appService.direction,
								disableClose: true,
								autoFocus: false,
								data: {  }
							});
							break;
						case "gotoPartialPayment": this.gotoPayment('partial'); break;
						case "gotoAddItems": this.gotoPayment('partial', 'items'); break;
						case "gotoByDiners": this.gotoPayment('partial', 'diners'); break;
						case "passOrder": this.dialogsService.passOrder(); break;
					}
				}
			});
		} else {
			this.gotoPayment(mode, subMode);
		}
	}

	gotoPayment(mode?, subMode?) {
		if (mode === 'tip') {
			this.$storage.order.isPartialPayment = true;
			this.$storage.order.grandTotal = 0;
		} else {
			if (this.$storage.check) {
				this.$storage.order.grandTotal = this.$storage.check.$$balanceDue;
			} else {
				this.$storage.order.grandTotal = this.$storage.order.balanceDue;
			}
		}
		this.prepareSteps(mode);
		if (!this.$storage.paymentAccounts.length) {
			return this.appService.alert({ content: 'MESSAGES.NO_SITE_PMS_FOUND' });
		}
		this.childOptions.subMode = subMode;
		this.$storage.paymentMode = mode;
		this.goFroward();
	}

	goFroward(ev?) {
		if (this.loadingStep) return;
		let _step = this.steps[this.step];
		if (_step.next) {
			this.setStep(_step.next);
		}
	}

	goBack(ev?) {
		if (this.loadingStep) return;
		const _step = this.steps[this.step];
		if (_step.back) this.setStep(_step.back);
	}


	gotoCheckout() {
		this.setStep(3);
	}

	makePayment() {

	}

	setStep(step) {
		this.childOptions.stepDirectionClass = step >= this.step ? 'faster fadeInUp' : 'faster fadeInUp';
		if (step == this.stepsMap.ticket) delete this.$storage.check;
		this.step = step;
		$(window).scrollTop(0);
	}

	close() {
		this.router.navigateByUrl(this.fromState);
	}

	onAddItemsClick(ev) {
		this.appService.addItemsToOrder();
	}

	// -------------------------------------------------------------------->

	async showTipDialog(args) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(TipDialogComponent, {
				width: "340px",
				maxWidth: '95vw',
				panelClass: 'rounded-dialog',
				backdropClass: 'dialog-backdrop-dark',
				direction: this.appService.direction,
				disableClose: true,
				data: { ...args },
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					if (result === 'CANCEL') return;
					resolve(result);
				} else {
					resolve(null);
				}
			});
		});
	}
}

